import type { NativeCallState } from './nativeBridge';

/** Metadata updates do not replace the authorized peer. State/pause transitions do. */
export const sameNativeCallScope = (a: NativeCallState, b: NativeCallState) =>
  a.meetingId === b.meetingId && a.generation === b.generation && a.state === b.state &&
  Boolean(a.accessVerifying) === Boolean(b.accessVerifying);

/** In-memory acknowledgements only: no receipt can authorize a different native peer. */
export type NativeViewportReceipt = { meetingId: string; generation: number; revision: number };
let revision = 0;
const acknowledged = new Set<(receipt: NativeViewportReceipt) => void>();
const refresh = new Set<() => void>();
export const nextViewportRevision = () => ++revision;
export const currentViewportRevision = () => revision;
export const acknowledgeNativeViewport = (receipt: NativeViewportReceipt) => {
  if (receipt.revision === revision) acknowledged.forEach(listener => listener(receipt));
};
export const onNativeViewportAcknowledged = (listener: (receipt: NativeViewportReceipt) => void) => {
  acknowledged.add(listener);
  return () => { acknowledged.delete(listener); };
};
export const onNativeViewportRefresh = (listener: () => void) => {
  refresh.add(listener);
  return () => { refresh.delete(listener); };
};
export const refreshNativeViewport = () => { refresh.forEach(listener => listener()); };
